module.exports = __webpack_public_path__ + "a6a99bc986b5659f91aadc416319b6f0.jpg";